import React, { useEffect, useState } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';

const navItems = [
  { path: '/', label: 'Home' },
  { path: '/chi-siamo', label: 'Chi Siamo' },
  { path: '/sviluppo-software-su-misura', label: 'Soluzioni Digitali' },
  { path: '/talent-strategy', label: 'Talent Strategy' },
  { path: '/privaprompt', label: 'PrivaPrompt' },
  { path: '/contatti', label: 'Contatti' }
];

const SiteHeader = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className="site-header">
      <div className="container header-inner">
        <Link to="/" className="brand">
          <img
            src="/static-site/logo.jpeg"
            alt="HelpSoftware logo"
            className="brand-logo"
          />
          <span>HelpSoftware</span>
        </Link>

        <button
          type="button"
          className="nav-toggle"
          onClick={() => setIsMenuOpen(open => !open)}
          aria-expanded={isMenuOpen}
          aria-label="Apri o chiudi il menu"
        >
          <span className="nav-toggle-line" />
          <span className="nav-toggle-line" />
          <span className="nav-toggle-line" />
        </button>

        <nav className={isMenuOpen ? 'main-nav open' : 'main-nav'}>
          {navItems.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                isActive ? 'nav-link active' : 'nav-link'
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default SiteHeader;
